import mdAxios from 'core/common/config/axios-config';
import {IDomainObject, lovValue} from "core/form/formUtils";
import {observable, action} from "mobx";
import {Shipment, SHIPMENTDIRECTION, ShipmentRepackaging, ShipmentRepackagingResource, SHIPMENTSTATUS, ShipmentVisit, SHIPMENTVISITSTEP} from "shipment/shipmentDomain";
import {PRIMITIVE, ID} from "core/metamodel/metaConstant";
import {TRequestParams} from "core/common/domain/commonDomain";
import moment from "moment";
import {FILTEROPERATOR, GridParams} from "../core/grid/domain/grid";
import {formatDate} from "core/common/utils/dateUtils";
import {LovItem} from "../core/metamodel/mdEntity";


class ShipmentService  {


  @observable public shipmentObject: Shipment;
  @observable public shipmentRepackagingObject: ShipmentRepackaging;
  @observable public shipmentVisitObject: ShipmentVisit;



  readShipment(shipmentId: number, params?: TRequestParams): Promise<Shipment> {
    return mdAxios.get('/shipment/' + shipmentId, {params: params})
      .then(response => new Shipment(response.data));
  }

  readShipments(registrationNumber: string,
                shipmentDate: string,
                shipmentDateOperator: FILTEROPERATOR,
                supplierId: number,
                direction: SHIPMENTDIRECTION,
                currentShipmentVisit: ShipmentVisit,
                ignoreVisitOrder: boolean): Promise<Shipment[]> {

    return ((ignoreVisitOrder) ?
       mdAxios.get('/shipments', {params: {registrationNumber, shipmentDate, shipmentDateOperator, supplierId, direction}})
         :
    this.readShipmentVisits(registrationNumber, null, shipmentDate, undefined, undefined, direction, null)
      .then(visits => {
        let olderVisitCount = visits.filter(visit => visit.shipmentVisitId !== currentShipmentVisit.shipmentVisitId && moment(visit.dateCreated).isBefore(currentShipmentVisit.dateCreated) ).length;
        console.log("olderVisitCount %s", olderVisitCount);
        return mdAxios.get('/shipments', {params: {registrationNumber, shipmentDate, shipmentDateOperator, supplierId, direction, visitOrder: olderVisitCount + 1}});
      })
  ).then(response => response.data.map(d => new Shipment(d)).filter(sh => !sh.shipmentVisit || lovValue(sh.shipmentVisit) === currentShipmentVisit.shipmentVisitId ));

  }


  saveShipment(shipment: Shipment): Promise<IDomainObject> {
    return mdAxios.post('/shipment', shipment, {showPrettyError: true})
      .then((response) => response.data);
  }

  deleteShipment(shipmentId: number): Promise<any> {
    return mdAxios.delete('/shipment/' + shipmentId, {showPrettyError: true});
  }


  readShipmentRepackaging(shipmentRepackagingId: number, params?: TRequestParams) {
    return mdAxios.get('/shipment-repackaging/' + shipmentRepackagingId, {params: params})
      .then(response => new ShipmentRepackaging(response.data));
  }

  saveShipmentRepackaging(shipmentRepackaging: ShipmentRepackaging): Promise<IDomainObject> {
    return mdAxios.post('/shipment-repackaging', shipmentRepackaging, {showPrettyError: true})
      .then((response) => response.data);
  }

  deleteShipmentRepackaging(shipmentRepackagingId: number): Promise<any> {
    return mdAxios.delete('/shipment-repackaging/' + shipmentRepackagingId, {showPrettyError: true});
  }

  readShipmentRepackagingResource(toolbarDate: Date, params?: TRequestParams): Promise<ShipmentRepackagingResource> {
    return mdAxios.get('/shipment-repackaging-resource/' + moment(toolbarDate).format("YYYY-MM-DD"), {params: params})
      .then(response => new ShipmentRepackagingResource(response.data));
  }

  saveShipmentRepackagingResource(shipmentRepackagingResource: ShipmentRepackagingResource): Promise<any> {
    return mdAxios.post('/shipment-repackaging-resource', shipmentRepackagingResource, {showPrettyError: true})
  }


  readShipmentVisit(shipmentVisitId: number, readShipments: boolean = false): Promise<ShipmentVisit> {
    return mdAxios.get('/shipment-visit/' + shipmentVisitId, {params: {readShipments}})
      .then(response => new ShipmentVisit(response.data));
  }

  readShipmentVisits(registrationNumber: string, visitDate: string, dateCreated: string, unassigned: boolean,
                     visitEndFilled: boolean, direction: SHIPMENTDIRECTION, step: SHIPMENTVISITSTEP): Promise<ShipmentVisit[]> {
    return mdAxios.get('/shipment-visits', {params: {registrationNumber, visitDate, dateCreated, unassigned, visitEndFilled, direction, step}})
      .then(response => response.data.map(d => new ShipmentVisit(d)));
  }


  saveShipmentVisit(shipmentVisit: ShipmentVisit, syncRegistrationNumber: boolean, syncShipmentStatus: SHIPMENTSTATUS,
                    syncShippedFromPlace: number, gridParams: GridParams, visitIdsToDelete: number[]): Promise<IDomainObject> {
    return mdAxios.post('/shipment-visit', shipmentVisit, {showPrettyError: true, params: {syncRegistrationNumber, syncShipmentStatus, syncShippedFromPlace, ...gridParams, visitIdsToDelete}})
      .then((response) => response.data);
  }


  deleteShipmentVisit(shipmentVisitId: number): Promise<any> {
    return mdAxios.delete('/shipment-visit/' + shipmentVisitId, {showPrettyError: true});
  }



  computeField(fieldName: string, params: {[key:string]: PRIMITIVE}): Promise<any> {
    return mdAxios.get("/shipment/compute", {params: Object.assign({fieldName}, params)})
      .then((response) => response.data);
  }
}

export default new ShipmentService();



// WEBPACK FOOTER //
// ./src/shipment/shipmentService.ts